import {
  MONTH_PICKER_DATE_PATTERN,
  MONTH_PICKER_MAX_YEAR,
  MONTH_PICKER_MIN_YEAR,
  MONTH_PICKER_MONTHS,
  MONTH_PICKER_NAMED_PATTERN,
  MONTH_PICKER_YEAR_PATTERN,
} from "./month-picker.constants";

export function toMonthValue(value?: string) {
  const input = value?.trim();
  if (!input) return "";
  const numeric = MONTH_PICKER_DATE_PATTERN.exec(input);
  if (numeric) {
    const month = Number(numeric[2]);
    return Number(numeric[1]) > 0 &&
      month >= 1 &&
      month <= MONTH_PICKER_MONTHS.length
      ? `${numeric[1]}-${String(month).padStart(2, "0")}`
      : "";
  }
  const named = MONTH_PICKER_NAMED_PATTERN.exec(input);
  if (!named || Number(named[2]) === 0) return "";
  const name = named[1].toLowerCase();
  const month = MONTH_PICKER_MONTHS.findIndex(
    (item) =>
      [item.toLowerCase(), item.slice(0, 3).toLowerCase()].includes(name) ||
      (item === "September" && name === "sept"),
  );
  return month >= 0 ? `${named[2]}-${String(month + 1).padStart(2, "0")}` : "";
}

export function formatMonthValue(value?: string) {
  const month = toMonthValue(value);
  return month
    ? `${MONTH_PICKER_MONTHS[Number(month.slice(5)) - 1].slice(0, 3)} ${month.slice(0, 4)}`
    : value?.trim() || "";
}

export function getMonthPickerYear(value?: string) {
  const input = toMonthValue(value).slice(0, 4) || value?.trim() || "";
  return MONTH_PICKER_YEAR_PATTERN.test(input) && Number(input) > 0
    ? Number(input)
    : new Date().getFullYear();
}

export function getMonthPickerBounds(min?: string, max?: string) {
  const minimum = toMonthValue(min);
  const maximum = toMonthValue(max);
  return {
    minimum,
    maximum,
    minYear: minimum ? Number(minimum.slice(0, 4)) : MONTH_PICKER_MIN_YEAR,
    maxYear: maximum ? Number(maximum.slice(0, 4)) : MONTH_PICKER_MAX_YEAR,
  };
}
